import Sizes from "./Sizes"
import Icons from "./Icons"
import Colors from "./Colors"

export const Tokens = {
    Icons,
    Colors,
    ...Sizes
}